module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Назад",
      "to": "/material/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), (_vm.canEdit) ? _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Редактирай",
      "to": '/material/' + _vm.material.id + '/edit'
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header clearfix"
  }, [_c('h4', {
    staticClass: "card-title pull-left"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.material.title) + "\n\t\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-icon pull-right",
    attrs: {
      "href": _vm.material.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" Отвори")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_c('strong', [_vm._v("Описание:")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.material.description) + "\n\t\t\t\t")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0), _c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.material.families), function(family) {
    return _c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": family
      }
    })
  })), _vm._v(" "), _c('p')])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Предоставен от:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15f6d0aa!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/share/MaterialView.vue
// module id = 639
// module chunks = 1